import sendIcon from "../../assets/icons/send.svg";

export default function InputField(props) {
  const { className, onClick } = props;

  return (
    <div className={`input-field ${className || ""}`} onClick={onClick}>
      <div className="input-field-text-wrapper">
        <div className="text-field valign-text-middle roobertvrt-regular-normal-alto-16px">
          Typ hier je antwoord
        </div>
      </div>
      <img className="send-icon" src={sendIcon} alt="send icon" />
    </div>
  );
}
